import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const CHAPTERS = [
  { n: "00", title: "Manifest", body: "Wir bauen keine schönen Webseiten. Wir bauen Systeme, die Schweizer Unternehmen sichtbar machen — und Anfragen liefern, Monat für Monat." },
  { n: "01", title: "Festpreis", body: "Ein Angebot innerhalb 48 Stunden. Keine Stundenzettel, keine Überraschungen, kein Kleingedrucktes." },
  { n: "02", title: "Ein Team", body: "Design, Content, Ads und Betreuung aus einer Hand. Kein Outsourcing. Ein persönlicher Ansprechpartner." },
];

function Chapter({ c, i }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
      className="grid grid-cols-12 gap-6 border-t border-black/10 py-10 md:py-14"
    >
      <div className="col-span-12 md:col-span-3 flex items-baseline gap-4">
        <span className="chapter-num">{c.n}</span>
        <span className="hidden md:inline gold-hairline w-16" />
      </div>
      <h3 className="col-span-12 md:col-span-3 font-serif-editorial text-3xl md:text-4xl">{c.title}</h3>
      <p className="col-span-12 md:col-span-6 text-[#0A0A0A]/75 text-base md:text-lg leading-relaxed max-w-xl">{c.body}</p>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section className="bg-[#FAFAF7] py-20 md:py-28">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="flex items-center gap-4 mb-10 md:mb-14">
          <span className="gold-hairline w-10" />
          <span className="chapter-num">Manifest · Unser Versprechen</span>
        </div>
        {CHAPTERS.map((c, i) => <Chapter key={c.n} c={c} i={i} />)}
        <div className="border-t border-black/10" />
      </div>
    </section>
  );
}
